import { stateOptions } from '../commonStateTaxData';

export const step1InitialQuestions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const step1Part2InitialQuestions = [
  {
    id: 'claim_options',
    title: 'Select one of the following for exemptions claimed:',
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'claim_yourself',
        shortName: 'You claim yourself',
      },
      {
        codeValue: 'claim_yourself_and_spouse',
        shortName: 'You claim yourself and spouse',
      },
      {
        codeValue: 'claim_head_of_household',
        shortName: 'Head of Household, and you claim yourself',
      },
      {
        codeValue: 'not_applicable',
        shortName: 'Not applicable',
      },
    ],
  },
  {
    id: 'dependents',
    title: 'Allowance(s) for your dependents, not including yourself or your spouse',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Additional amount, if any, you want deducted from each paycheck:',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Please select filing status:',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single or married with two or more incomes',
      },
      {
        codeValue: 'married_filing_jointly',
        shortName: 'Married filing jointly',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of Household',
      },
    ],
  },
];

export const ver01142020 = {
  lowIncome: [
    '$12,675 to $15,200',
    '$21,375 to $25,200',
    '$25,726 to $31,300',
    '$18,021 to $22,000',
    '$21,482 to $25,100',
  ],
};

export const ver11172021 = {
  lowIncome: [
    '$13,055 to $15,700',
    '$22,016 to $26,100',
    '$26,497 to $32,200',
    '$18,561 to $22,600',
    '$22,126 to $26,000',
  ],
};

export const ver11162022 = {
  lowIncome: [
    '$13,447 to $16,000',
    '$22,676 to $26,700',
    '$27,292 to $33,100',
    '$19,118 to $23,300',
    '$22,790 to $26,600',
  ],
};
